<template>
  <b-container fluid>
    <div id="full-width-section" class="align-items-center d-flex justify-content-between mb-4 row">
      <div class="d-flex flex-row align-items-center">
        <div v-if="edit">
          <b-form-input v-model="title"></b-form-input>
        </div>
        <div v-else>
          {{ title.length > 5 ? title.substring(0, 5) + '...' : title }}
        </div>

        <div class="ml-2">
          <b-button v-if="edit" variant="dark" @click="edit = !edit" size="sm">
            <b-icon icon="check2"></b-icon>
          </b-button>
          <b-button v-else variant="dark" @click="edit = !edit" size="sm">
            <b-icon icon="pencil"></b-icon>
          </b-button>
        </div>
      </div>

      <div class="text-right">
        <b-btn variant="outline-secondary" class="px-5 mr-3" @click="$router.push({name: 'KagechiUploadEditGPX'})">戻る</b-btn>
        <b-btn variant="primary" class="px-4" @click="next">
          <div class="text-left">ダウンロード</div>
        </b-btn>
      </div>
    </div>

    <div>
      <b-alert variant="danger" :show="!!errors.error">
        <div>{{ errors.error }}</div>
      </b-alert>
    </div>

    <div class="d-flex mb-4">
      <b-button v-if="helpUrl != ''" variant="secondary" @click="openInNewTab(helpUrl)" class="align-items-center d-flex mr-2">
        <span class="align-items-center bg-white d-flex mr-2 rounded-pill" style="width: 18px; height: 12px;">
          <b-icon-book-fill variant="info"/>
        </span>
        詳細説明を見る
      </b-button>
      <play-video-btn v-if="helpUrlVideo"></play-video-btn>
    </div>

    <b-tabs content-class="mt-3">
      <template #tabs-start>
        <li role="presentation" class="align-self-center border-b-3 border-dark-grey border-solid border-t-0 border-x-0 nav-item page-sum-label px-4 py-2">
          ページ数合計：{{files.length}}枚
        </li>
      </template>
      <b-tab v-for="(f, index) in files" :key="index">
        <template #title>{{f.name}}</template>
        <trimming-image ref="trimmingImages" :base64-image="f.image" :fileIndex="index" />
      </b-tab>
      <template #tabs-end>
        <li class="grow border-3 border-b-3 border-solid border-dark-grey border-x-0 border-t-0"></li>
      </template>
    </b-tabs>

    <video-modal v-if="helpUrlVideo" :url="helpUrlVideo"></video-modal>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import TrimmingImage from '../../components/TrimmingImageEditGPX'
import VideoModal from '../../components/VideoModal'
import PlayVideoBtn from '../../components/PlayVideoBtn'
import CanvasMixin from '../../mixins/canvas'
import GPX from '../../mixins/gpx'
import validation from '../../mixins/validation'
import videoWatch from '../../mixins/video_watch'

export default {
  name: 'Trimming',
  mixins: [CanvasMixin, validation, GPX, videoWatch],
  components: {
    TrimmingImage,
    VideoModal,
    PlayVideoBtn
  },
  data: () => ({
    main: {},
    areaVal: 0,
    gcs: undefined,
    gs: {},
    keys: undefined,
    keyIdx: 0,
    helpUrl: '',
    helpUrlVideo: '',
    needPlayVideo: false,
    edit: false
  }),
  watch: {
    loadingStatus () {
      if (this.loadingStatus) {
        this.$emit('loading', true)
      } else {
        this.$emit('loading', false)
      }
    },
    gsCoordinates () {
      const coordinatesData = this.createCoordinatesData()
      this.deleteCoordinates()
      this.saveCoordinates(coordinatesData)
    }
  },
  mounted () {
    window.addEventListener('resize', this.resizeWindow)
  },
  created () {
    this.$emit('loading', true)

    // 操作説明のURL取得
    this.axios.get('/api/master/search/help_urls').then(res => {
      const autoPlayedVideos = localStorage.getItem('autoPlayedVideos')
        ? JSON.parse(localStorage.getItem('autoPlayedVideos')) : []

      this.helpUrl = res.data.urls.editGPX
      this.helpUrlVideo = res.data.urls.editGPX_video

      if (this.helpUrlVideo && !autoPlayedVideos.includes(this.helpUrlVideo)) {
        this.needPlayVideo = true
        autoPlayedVideos.push(this.helpUrlVideo)
        localStorage.setItem('autoPlayedVideos', JSON.stringify(autoPlayedVideos))
      }
    }).catch(error => {
      this.errors = { error: `システムエラーが発生しました。${error}` }
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })

    if (Object.keys(this.coordinates).length === 0) {
      this.errors = { error: '最初からやり直してください。' }
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      setTimeout(() => {
        this.gcs = this.coordinates
        this.keys = Object.keys(this.gcs)
        this.keyIdx = 0
        this.loopFiles(0).then(() => {
        })
      }, 300)
    }

    this.$emit('loading', false)
  },
  computed: {
    ...mapState({
      coordinates: state => state.gpx.coordinates,
      files: state => state.gpx.files,
      vertexes: state => state.gpx.vertexes,
      loading: state => state.gpx.loadingStatus,
      gsCoordinates: state => state.googleMap.gsCoordinates,
      loadingStatus: state => state.googleMap.loadingStatus,
      mainId: state => state.googleMap.mainId,
      title: state => state.gpx.title
    }),
    title: {
      get () {
        return this.$store.state.gpx.title
      },
      set (value) {
        this.$store.commit('gpx/updateTitle', value)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeWindow)
  },
  methods: {
    ...mapActions('gpx',
      [
        'deleteCoordinates',
        'saveCoordinates',
        'getFilesData'
      ]
    ),

    ...mapActions('googleMap',
      [
        'setMainId',
        'deleteMarkers',
        'deleteGSCoordinates'
      ]
    ),

    next () {
      const data = []
      this.gsCoordinates.forEach((gs) => {
        data.push(
          {
            lat: gs.lat,
            lon: gs.lon,
            omitt: false
          }
        )
      })

      // ダウンロードをローカルで行う
      const gpx = this.makeGpx(data)
      const a = document.createElement('a')
      const blob = new Blob([gpx], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      document.body.appendChild(a)
      a.download = this.title + '.gpx'
      a.href = url
      a.click()
    },
    findOmittIdx (arry, maxIdx) {
      const omittResult = []
      for (let i = 0; i < maxIdx; i++) {
        let MatchFlag = false
        arry.forEach((a) => {
          const idx = parseInt(a.name.split('頂点')[1]) - 1
          if (idx === i) {
            // 見つかった場合
            MatchFlag = true
          }
        })
        if (MatchFlag === false) {
          omittResult.push(i)
        }
      }
      return omittResult
    },
    resizeWindow () {
      this.$refs.trimmingImages.forEach(component => {
        component.initCanvas()
      })
    },
    getVtx (paramKey) {
      return new Promise((resolve) => {
        const key = paramKey
        if (this.gcs[key].coordinates.lon > 0 && this.gcs[key].coordinates.lat > 0) {
          this.axios.get(`/api/kagechi/gpx?lon=${this.gcs[key].coordinates.lon}&lat=${this.gcs[key].coordinates.lat}`).then(res => {
            this.gs[this.gcs[key].crdnIndex] = {
              x: res.data.x,
              y: res.data.y,
              // 緯度，経度 のデータ取得を追加
              lat: Number(this.gcs[key].coordinates.lat),
              lon: Number(this.gcs[key].coordinates.lon)
            }
            resolve()
          })
        }
      })
    },
    loopVtx () {
      return new Promise((resolve) => {
        if (this.keys.length < 1) {
          resolve()
        } else {
          this.getVtx(this.keys[0]).then(() => {
            this.keys.shift()
            this.loopVtx().then(() => {
              resolve()
            })
          })
        }
      })
    },
    loopFiles (fIdx) {
      return new Promise((resolve) => {
        if (fIdx === this.files.length) {
          resolve()
        } else {
          this.$refs.trimmingImages[fIdx].addPlat()
          this.$refs.trimmingImages[fIdx].onSelectChangePlat(this.$refs.trimmingImages[fIdx].plats[0])
          const prevIdx = this.keyIdx
          this.loopVtx(prevIdx).then(() => {
            // 座標変換
            const gs = this.adjustPlatSize(this.gs)
            const vtxs = []
            Object.keys(gs).forEach((key, index) => {
              vtxs.push(gs[key])
            })
            if (vtxs.length > 2) {
              this.areaVal = Math.round(this.calcPlatArea(vtxs) * 100) / 100
              const sumVrx = vtxs.map((o) => { return parseFloat(o.x) + parseFloat(o.y) })
              vtxs.forEach((v, index) => {
                gs[index].x = v.x * 400 / Math.max(...sumVrx) + 100
                gs[index].y = v.y * 400 / Math.max(...sumVrx) + 100
                // 緯度，経度 の項目を追加
                gs[index].lat = v.lat
                gs[index].lon = v.lon
              })
              this.$refs.trimmingImages[fIdx].plotCoordinates(gs)
            } else if (vtxs.length === 2) {
              // 点が２点の場合
              // 緯度，経度 の項目を追加
              gs[0].lat = vtxs[0].lat
              gs[0].lon = vtxs[0].lon
              gs[1].lat = vtxs[1].lat
              gs[1].lon = vtxs[1].lon

              if (String(vtxs[0].x) === '0' && String(vtxs[0].y) === '0') {
                if (vtxs[1].x > vtxs[1].y) {
                  gs[0].x = 100
                  gs[0].y = 100
                  gs[1].x = vtxs[1].x * (200 / vtxs[1].x) + 100
                  gs[1].y = vtxs[1].y * (200 / vtxs[1].x) + 100
                } else {
                  gs[0].x = 50
                  gs[0].y = 50
                  gs[1].x = vtxs[1].x * (200 / vtxs[1].y) + 100
                  gs[1].y = vtxs[1].y * (200 / vtxs[1].y) + 100
                }
              } else {
                if (vtxs[0].x > vtxs[0].y) {
                  gs[1].x = 100
                  gs[1].y = 100
                  gs[0].x = vtxs[0].x * (200 / vtxs[0].x) + 100
                  gs[0].y = vtxs[0].y * (200 / vtxs[0].x) + 100
                } else {
                  gs[1].x = 100
                  gs[1].y = 100
                  gs[0].x = vtxs[0].x * (200 / vtxs[0].y) + 100
                  gs[0].y = vtxs[0].y * (200 / vtxs[0].y) + 100
                }
              }
              this.$refs.trimmingImages[fIdx].plotCoordinates(gs)
            }
            this.gs = {}
            this.loopFiles(fIdx + 1).then(() => {
              resolve()
            })
            if (fIdx === this.files.length - 1) {
              this.$emit('loading', false)
            }
          })
        }
      })
    },
    createCoordinatesData () {
      const coordinatesData = {}
      for (let i = 0; i < this.gsCoordinates.length; i++) {
        coordinatesData[0 + '_' + i] = {
          fileIndex: 0,
          crdnIndex: i,
          coordinates: {
            lat: this.gsCoordinates[i].lat,
            lon: this.gsCoordinates[i].lon
          }
        }
      }
      return coordinatesData
    },
    openInNewTab (url) {
      window.open(url, '_blank', 'noreferrer')
    },
    makeGpx (data) {
      let wpt = ''

      data.forEach((vtx) => {
        wpt += `<wpt lat="${vtx.lat}" lon="${vtx.lon}" omitt="${vtx.omitt}"></wpt>`
      })

      return `<?xml version='1.0' encoding='utf-8' ?>
<gpx xmlns="http://www.topografix.com/GPX/1/1" xmlns:b="http://www.bizstation.jp/waypoint_extension" creator="Drogger GPS for Android 2.9.177" version="1.1">
${wpt}
</gpx>`
    }
  }
}
</script>

<style scoped>

</style>
